import { createContext, FC, PropsWithChildren, useContext, useMemo } from 'react';

import useMeasure, { RectReadOnly } from 'react-use-measure';

import { Box } from '@ui';

const BoundsContext = createContext<Pick<RectReadOnly, 'width' | 'height'>>({
    width: 0,
    height: 0,
});

export type OptionsProps = {
    columns: 1 | 2;
    showSkeleton?: boolean;
    videoCount: number;
};
const OptionsContext = createContext<OptionsProps>({
    columns: 1,
    videoCount: 1,
});

export const useBounds = () => useContext(BoundsContext);
export const useOptions = () => useContext(OptionsContext);

export const ContextProvider: FC<PropsWithChildren<OptionsProps>> = ({
    children,
    columns,
    showSkeleton,
    videoCount,
}) => {
    const [ref, bounds] = useMeasure({ debounce: 250 });

    const options = useMemo(() => ({ columns, showSkeleton, videoCount }), [columns, showSkeleton, videoCount]);
    const boundsMemo = useMemo(
        () => ({ width: Math.floor(bounds.width), height: Math.floor(bounds.height) }),
        [bounds.width, bounds.height],
    );

    return (
        <Box ref={ref} flexGrow={1} width={'100%'} height={'100%'}>
            {!bounds.width || !bounds.height ? null : (
                <BoundsContext.Provider value={boundsMemo}>
                    <OptionsContext.Provider value={options}>{children}</OptionsContext.Provider>
                </BoundsContext.Provider>
            )}
        </Box>
    );
};
